import React from 'react';
import ExternalVisualization from 'components/report-content/components/external-visualization/ExternalVisualization';
import ExternalVisualizationEditPanel from 'components/report-content/components/external-visualization/ExternalVisualizationEditPanel';
import { AbstractComponentBuilder, ComponentSettingsExternalVisualization } from '@report-content';

export default class ExternalVisualizationComponentBuilder extends AbstractComponentBuilder<ComponentSettingsExternalVisualization> {
    getComponent() {
        return (
            <ExternalVisualization
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <ExternalVisualizationEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
